import * as actionTypes from "../../actions/issuerVerification/actionTypes";

const initialState = {
  issuerAccountsList: [],
  issuerAccountObj: null,
  totalCount: 0,
  loading: false,
  error: null,
};

const getIssuerAccountsStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const getIssuerAccountsFail = (state, action) => {
  return {
    ...state,
    loading: false,
    error: action.error,
  };
};

const getIssuerAccountsSuccess = (state, action) => {
  return {
    ...state,
    issuerAccountsList: action.response?.docs,
    totalCount: action.response?.totalCount,
    loading: false,
  };
};

const getIssuerAccountSuccess = (state, action) => {
  return {
    ...state,
    issuerAccountObj: action.response,
    loading: false,
  };
};

export const issuerVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ISSUER_ACCOUNTS_START:
      return getIssuerAccountsStart(state, action);
    case actionTypes.GET_ISSUER_ACCOUNTS_FAIL:
      return getIssuerAccountsFail(state, action);
    case actionTypes.GET_ISSUER_ACCOUNTS_SUCCESS:
      return getIssuerAccountsSuccess(state, action);
    case actionTypes.GET_ISSUER_ACCOUNT_SUCCESS:
      return getIssuerAccountSuccess(state, action);
    default:
      return state;
  }
};
